module.exports = __webpack_public_path__ + "img/icon-logo.b23f607c.png";